module.exports = __webpack_public_path__ + "static/media/iris_editor_histogram.b41be18c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/iris_editor_histogram.png
// module id = 391
// module chunks = 17